import styled from 'styled-components';
import {getColorFromTheme} from '@ui/ui-utils';

export const EditGoalOverlay = styled.div`
  position: fixed;
  z-index: 1200;
  inset: 0;
  background: rgba(30, 30, 47, 0.48);
`;

export const EditGoalSidePanel = styled.aside`
  position: fixed;
  z-index: 1201;
  top: 0;
  right: 0;
  width: min(560px, 100vw);
  height: 100vh;
  overflow: hidden;
  background: ${getColorFromTheme('white')};
  box-shadow: -8px 0 32px rgba(30, 30, 47, 0.12);

  form {
    height: 100%;
  }
`;
